export interface GetBookbindingTargetCollectionsRequest {
  collectionId: number
  collectionIds: number[]
  collectionNo: string
}

export function GetBookbindingTargetCollectionsRequestToJSON(
  value: GetBookbindingTargetCollectionsRequest
): any {
  return {
    collection_id: value.collectionId !== 0 ? value.collectionId : undefined,
    collection_ids:
      value.collectionIds.length > 0 ? value.collectionIds : undefined,
    collection_no: value.collectionNo !== '' ? value.collectionNo : undefined
  }
}
